import React from "react";
import "./Page.css";
import useStore from "../store.js";
import { BlocksRenderer } from "@strapi/blocks-react-renderer";
import Button from "../components/Button/Button.js";
import logo from "../assets/img/Logo.svg";
import { useNavigateWithVars } from "../hooks/useNavigateWithVars";

const Page = (props) => {
  const getLocalized = useStore((state) => state.getLocalized);
  const game = useStore((state) => state.game);
  const gameState = useStore((state) => state.gameState);
  const sessionData = useStore((state) => state.sessionData);

  const allCharactersCheckedIn = useStore(
    (state) => state.allCharactersCheckedIn,
  );
  const setGameState = useStore((state) => state.setGameState);

  const isHost = useStore((state) => state.isHost);
  const navigateTo = useNavigateWithVars();

  console.log("AllCharactersCheckedIn", allCharactersCheckedIn);

  return (
    <div
      className={`Page Start${props.className ? " " + props.className : ""}${
        sessionData?.ended ? " ended" : ""
      }`}
    >
      <img src={logo} className="App-logo" alt="logo" />
      <h2>
        {!sessionData?.ended ? (
          <BlocksRenderer content={getLocalized("texts", "StartHeadline")} />
        ) : (
          <BlocksRenderer content={getLocalized("texts", "EndHeadline")} />
        )}
      </h2>
      <div className="GameTitle">
        <h1>{game?.Name}</h1>
        <h3>{game?.Subtitle}</h3>
      </div>
      {gameState > 0 && gameState <= getLocalized("game", "Rounds") && (
        <Button
          className="full"
          onClick={() => navigateTo(`round/${gameState}`)}
        >
          {`${getLocalized("texts", "Runde")} ${gameState}`}
        </Button>
      )}

      {!sessionData?.ended && isHost && (
        <>
          {(!allCharactersCheckedIn || gameState > -1) && (
            <Button className="full" onClick={() => navigateTo(`characters/`)}>
              <BlocksRenderer
                content={
                  gameState === -1
                    ? getLocalized("texts", "StartButtonText")
                    : getLocalized("texts", "StartButtonTextAfterStart")
                }
              />
            </Button>
          )}

          {allCharactersCheckedIn && gameState === -1 && (
            <Button className="full" onClick={() => setGameState(0)}>
              <BlocksRenderer content={getLocalized("texts", "SpielStarten")} />
            </Button>
          )}

          {isHost && (
            <Button
              className="full"
              onClick={() => {
                navigateTo(`downloads/`);
              }}
            >
              {getLocalized("texts", "Downloads")}
            </Button>
          )}
        </>
      )}
    </div>
  );
};

export default Page;
